// 课程部分类型
import {CourseLivePlan} from "@/models/live/courseLivePlan";

export type CoursePartType = 'LIVE' | 'RECORDED' | 'PROJECT' | 'EXAM'
export const CoursePartTypeEnums = {
  LIVE: {text: '直播'},
  RECORDED: {text: '录播'},
  PROJECT: {text: '作业'},
  EXAM: {text: '考试'},
}
// 解锁类型
export type UnlockType = 'FREE' | 'NORMAL' | 'FIXED_DAY' | 'CODE' | 'RMB' | 'SHARE' | 'EVALUATION' | 'LOCK' | 'TBD'
export const UnlockTypeEnums = {
  FREE: {text: '"自由解锁（试学，正式，退课都可以学不做限制）"'},
  NORMAL: {text: '"正式购买状态解锁"'},
  FIXED_DAY: {text: '"固定日解锁并且为正式购买状态"'},
  CODE: {text: '"解锁码解锁并且为正式购买状态"'},
  RMB: {text: '"人民币解锁并且为正式购买状态"'},
  SHARE: {text: '"分享解锁并且为正式购买状态"'},
  EVALUATION: {text: '"测评解锁并且为正式购买状态"'},
  LOCK: {text: '"手动解锁（班主任解锁）"'},
  TBD: {text: '"未更新"'},
}

/**
 * 学习计划内容
 */
export interface CoursePlanPart {
  id: number;
  courseId: number;
  planId: number;
  type: CoursePartType;
  partName: string;
  partDesc: string;
  tag: string;
  difficulty: number;
  sort: string;
  unlockType: UnlockType;
  unlockProp: string;
  courseLivePlan: CourseLivePlan;
}

// 用户学习计划内容状态
export type PlanPartStatus = 'UNLEARNED' | 'LEARNING' | 'FINISHED'
export const PlanPartStatusEnums = {
  UNLEARNED: {text: '未完成'},
  LEARNING: {text: '学习中'},
  FINISHED: {text: '已学习'},
}

/**
 * 用户学习计划部分
 */
export interface UserCoursePlanPart {
  userId: number;
  courseId: number;
  planId: number;
  partId: number;
  unlockType: UnlockType;
  unlockProp: string;
  unlockValue: string;
  startTime: Date;
  status: PlanPartStatus;
  rate: number;
}
